import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    'en': {
        mainMenu: {
            mainMenu: "Main Menu",
            userMenu: "User Menu",
            myProjects: "My Projects",
            settings: "Settings",
            manual: "Manual",
            logout: "Logout"
        },
        login: {
            loginTxt: "Login",
            loginDesc: "Sign In to your account",
            holderUsername: "Username",
            holderPassword: "Password",
            userLogin: "Username is required",
            passLogin: "Password is required",
            subLogin: "Login",
            viewerDesc: "Viewer for visualization schemes of Vizweb applications"
        },
        project: {
            manageProjects: "Manage Projects",
            viewProject: "View Project",
            projListName: "Name",
            projListDesc: "Description",
            projLocation: "Location",
            projListAct: "Actions",
            openProject: "Open project",
            projStatusNew: "New",
            projStatusActive: "Active",
            projStatusEdit: "In edit",
            projStatusSuspend: "Suspended",
            projectViewer: {
                commandRightsOn: "Command turned on",
                commandRightsOff: "Command turned off",
                modules: "Stations",
                displays: "Displays",
                mainPage: "Main page",
                sendValueTooltip: "Send value",
                invalidInput: "Invalid input",
                viewerValue: "Value",
                viewerDesc: "Description",
                viewerEdit: "Edit",
                stopConnection: "Stop connection",
                reconnect: "Reconnect",
                varSuccSet: "Value successfully set",
                errInitWs: "Error while loading data, try to refresh page",
                errStartWs: "Connection could not be established",
                errInvokeData: "Data cannot be refreshed now",
                errGetData: "Error while refreshing data",
                connect: "Connected",
                disconnect: "Disconnected",
                errSendStopped: "Cannot change value while disconnected",
                errSendInvoke: "Cannot change value. Authorization problem",
                setNewValueModal: "Set new value",
                collapseAll: "Collapse all",
                expandAll: "Expand all",
                exportExpanded: "Export csv",
                extraTagSuccess: "Command finished successfully",
                watchdog: "Watchdog",
                watchdogLastMessage: "Last received message for device:",
                mobileCanvasHint: "One finger scrolls the page. Use two fingers to move the display; pinch to zoom."
            },
            graphViewer: {
                title: "Graph Viewer",
                axisX: "Date",
                axisY: "Value",
                day: "24 Hours",
                three: "3 Days",
                custom: "Custom",
                customFrom: "From",
                customTo: "To",
                customShow: "Show custom graph",
                drawGraph: "Draw graph",
                customExport: "CSV Export of trend values",
                pdfExport: "Consumption PDF Report",
                csvExport: "Consumption CSV Report",
                csvExportReading: "Reading CSV Report",
                pdfExportReading: "Reading PDF Report",
                pdfExportThreshold: "Reading threshold [minutes]",
                exportInProgress: "Export in progress, please wait…",
                presetLoading: "Loading preset trends, please wait…",
                presetGraphLoading: "Loading trend data for graph, please wait…",
                presetGraphTooManyTitle: "Too many trends for graph",
                presetGraphTooMany: "Drawing more than {max} trends on the graph is not supported. This preset has {count} active trends.",
                exportHeaderDate: "Date and time",
                exportFileHeader: "Export values (from - to):",
                exportHeaderValue: "Value",
                exportSemicolon: "; (Semi-colon)",
                exportComma: ", (Comma)",
                maxGraphDraw: "Maximum of charts to draw",
                toggleFullScreen: "Switch to fullscreen mode",
                toggleZoom: "Turn on/off zoom",
                setRange: "Set Y-range",
                clearRange: "Reset Y-range",
                resetZoom: "Reset zoom",
                setCustomSize: "Set custom size",
                resetSize: "Reset size",
                graphWidth: "Width (px)",
                graphHeight: "Height (px)",
                downloadGraph: "Download PNG",
                printGraph: "Print graph",
                setThresholds: "Set thresholds",
                yThresholdMax1: "Y Threshold Max 1",
                yThresholdMax2: "Y Threshold Max 2",
                yThresholdMin1: "Y Threshold Min 1",
                yThresholdMin2: "Y Threshold Min 2",
                yThresholdLine1: "Line 1",
                yThresholdLine2: "Line 2",
                yThresholdLine3: "Line 3",
                yThresholdLine4: "Line 4",
                thresholdsHelp: "Up to 4 optional horizontal lines on the Y axis. Same dashed stroke. Use + to apply.",
                graphYFrom: "Y from",
                graphYTo: "Y to",
                yRangeHelp: "Visible Y-axis range. Leave empty for automatic scale. Use the frame button to apply.",
                sizeHelp: "Chart size in pixels. You can set width, height, or both. Empty fields are fitted to the screen.",
                iconLegendDownload: "PNG",
                iconLegendPrint: "Print",
                iconLegendFullscreen: "Fullscreen",
                iconLegendZoom: "Zoom",
                iconLegendClearRange: "Reset Y",
                iconLegendResetZoom: "Reset zoom",
                customToolsPanel: "Custom range and export",
                customToolsExport: "Export",
                customToolsConsumption: "Consumption",
                customToolsReading: "Reading",
                chartSettingsPanel: "Chart settings",
                reports: {
                    projectName: "Project",
                    presetName: "Preset",
                    userName: "User",
                    dateGen: "Date of generation",
                    id: "ID",
                    unit: "Unit",
                    description: "Description",
                    consumption: {
                        dateFrom: "Date from",
                        dateTo: "Date to",
                        startValue: "Initial value",
                        endValue: "Final value",
                        sumValue: "Consumption",
                        totalSum: "Total"
                    },
                    reading: {
                        date: "Reading date",
                        value: "Reading"
                    },
                    footer: "Auto-generated using Tronic Control Viewer (www.vizleda.cz)"
                }
            },
            alarmsExport: {
                selectAll: "Select/Unselect all",
                alarmsProject: "Alarms",
                currentAlarms: "Current alarms",
                alarmsPage: "Alarms between given dates",
                selectStations: "Select stations:",
                selectPreset: "Select preset:",
                selectAlarms: "Select alarms:",
                exportAlarms: "Date and download:",
                mainText: "To export alarms, please follow these steps:",
                step1: "Select stations",
                step2: "Select alarms to view",
                step3: "Choose dates from-to",
                step4: "View alarms",
                infoText: "If you want to change your previous step, you can always do that and data will be generated again.",
                selectStationsConfirm: "Select stations",
                selectPresetConfirm: "Select preset",
                selectAlarmsFinal: "Select alarms",
                downloadAlarms: "Download in CSV",
                generateAlarms: "View alarms",
                noAlarmsGenerated: "No alarms logs between selected dates.",
                alarmsExported: "Alarms were successfully listed."
            },
            trendsExport: {
                trendsProject: "Trends",
                trendsPage: "Trends graphs and export",
                viewTrends: "Trends list",
                mainText: "To view and export trends, please follow these steps:",
                step1: "Select stations or preset:",
                step2: "Select trend to view or add new trend to the existing graph.",
                step3: "To export, choose 'custom' and set dates from-to.",
                step4: "To view given preiod, you can view data in the graph or immediately export with 'CSV Export'",
                infoText: "If you want to change selected stations, you can always do that and trends will be generated again",
                noTrendsGenerated: "No trends logs between selected dates.",
                trendsExported: "Trends were successfully listed.",
                viewGraph: "View graph",
                addToGraph: "Add to existing graph"
            },
            schedulesExport: {
                schedulesProject: "Schedules",
                schedulesPage: "Device time schedules",
                schedulesStatus: "Retrieval state",
                schedulesInfo: "Information",
                schedulesType: "Schedules type",
                schedulesLastUpdate: "Last update",
                schedulesTable: "Time schedules",
                buttonUpdate: "Update",
                buttonUpdateTitle: "Send updated schedules times to device",
                buttonReset: "Reset",
                buttonResetTitle: "Reset the schedules time retrieval",
                buttonStop: "Stop",
                buttonStopTitle: "Manually stop the retrieval and put it InError",
                buttonDelete: "Delete",
                buttonDeleteTitle: "Will delete schedules from the system memory",
                confirmationButton: "Confirm please:",
                notDeletedInfo: "Could not delete the time schedule. Try to refresh your page"
            },
            eventsExport: {
                eventsProject: "Events",
                eventsPage: "Events between given dates",
                selectStations: "Select stations:",
                selectEvents: "Select events:",
                exportEvents: "Date and download:",
                mainText: "To export events, please follow these steps:",
                step1: "Select stations",
                step2: "Select events to view",
                step3: "Choose dates from-to",
                step4: "View events",
                infoText: "If you want to change your previous step, you can always do that and data will be generated again.",
                selectStationsConfirm: "Select stations",
                selectEventsFinal: "Select events",
                downloadEvents: "Download in CSV",
                generateEvents: "View events",
                noEventsGenerated: "No events logs between selected dates.",
                eventsExported: "Events were successfully listed."
            }
        },
        settings: {
            header: "Account settings",
            editAcc: "Edit account: ",
            nameReq: "Name is required",
            emailReq: "Email is required",
            name: "Name",
            address: "Address",
            contact: "Contact",
            primTelNum: "Primary tel. number",
            secTelNum: "Secondary tel. number",
            ico: "ICO",
            dic: "DIC",
            subEdit: "Edit Account",
            changePass: "Change Password",
            oldPass: "Old password",
            oldPassReq: "Old password is required",
            newPass: "New password",
            newPassReq: "New password is required",
            newPassConf: "Confirmation of new password",
            newPassConfReq: "Confirmation of new password is required",
            passErr: "New passwords are not the same",
            confPassChange: "Confirm password change",
            succPassChange: "Password successfuly changed",
            noChanges: "No changes detected",
            accSuccUpdate: "Account successfuly updated"
        },
        other: {
            retrDataError: "We're sorry, we're not able to retrieve data at the moment, please try later",
            loading: "Loading...",
            clear: "Clear",
            searchHolder: "Type to Search",
            filter: "Filter",
            perPage: "Per Page",
            p404Header: "Oops! You're lost.",
            p404Text: "The page you are looking for was not found.",
            p401Header: "Oops! You should not be here.",
            p401Text: "You do not have claim rights for the page you are looking for.",
            return: "Return"
        },
        manual: {
            title: "User manual",
            lead: "VizWeb Viewer. For operators in the browser.",
            search: "Search the manual",
            clear: "Clear",
            print: "Print",
            prev: "Previous match",
            next: "Next match",
            toc: "Contents",
            showToc: "Contents",
            hideToc: "Hide contents",
            nothing: "Nothing found.",
            parts: "Sections: {count}",
            foundParts: "Matching sections: {count}",
            match: "{current} / {total}",
            printTitle: "VizWeb Viewer — user manual",
            printLead: "For operators and customers. Pictures show the controls, not one specific plant."
        }
    },
    'cs': {
        mainMenu: {
            mainMenu: "Hlavní Menu",
            userMenu: "Uživatelské Menu",
            myProjects: "Moje projekty",
            settings: "Nastavení",
            manual: "Manuál",
            logout: "Odhlásit se"
        },
        login: {
            loginTxt: "Přihlášení",
            loginDesc: "Přihlašte se do svého účtu",
            holderUsername: "Uživatelské jméno",
            holderPassword: "Heslo",
            userLogin: "Chybí uživatelské jméno",
            passLogin: "Chybí heslo",
            subLogin: "Přihlásit se",
            viewerDesc: "Vizualizace a správa technologií řízených TRONIC 2000\xAE"
        },
        project: {
            manageProjects: "Moje projekty",
            viewProject: "Prohlížeč projektů",
            projListName: "Název",
            projListDesc: "Popis",
            projLocation: "Lokace",
            projListAct: "Akce",
            openProject: "Otevřít projekt",
            projStatusNew: "Nový",
            projStatusActive: "Aktivní",
            projStatusEdit: "V úpravě",
            projStatusSuspend: "Pozastavený",
            projectViewer: {
                commandRightsOn: "Velení povoleno",
                commandRightsOff: "Velení blokováno",
                modules: "Zařízení",
                displays: "Obrazovky",
                mainPage: "Hlavní stránka",
                sendValueTooltip: "Odeslat hodnotu",
                invalidInput: "Hodnota není validní",
                viewerValue: "Hodnota",
                viewerDesc: "Popis",
                viewerEdit: "Změna",
                stopConnection: "Zastavit komunikaci",
                reconnect: "Připojit se",
                varSuccSet: "Hodnota úspěšně nastavena",
                errInitWs: "Chyba při načítání dat, zkuste obnovit stránku",
                errStartWs: "Nepovedlo se navázat spojení",
                errInvokeData: "Data nemohou být momentálně aktualizována",
                errGetData: "Chyba při aktualizaci dat",
                connect: "Připojeno",
                disconnect: "Odpojeno",
                errSendStopped: "Nelze měnit hodnotu, když je přerušená komunikace",
                errSendInvoke: "Nelze změnt hodnotu. Chyba autorizace",
                setNewValueModal: "Nastavit novou hodnotu",
                collapseAll: "Zabalit vše",
                expandAll: "Rozbalit vše",
                exportExpanded: "Export csv",
                extraTagSuccess: "Příkaz proběhl úspěšně",
                watchdog: "Watchdog",
                watchdogLastMessage: "Poslední přijatá zpráva pro zařízení:",
                mobileCanvasHint: "Jedním prstem posouváte stránku. Dvěma prsty posouváte obrazovku, stažením nebo roztažením přibližujete."
            },
            graphViewer: {
                title: "Nahlížení grafů",
                axisX: "Datum",
                axisY: "Hodnota",
                day: "24 Hodin",
                three: "3 Dny",
                custom: "Volitelné",
                customFrom: "Od",
                customTo: "Do",
                drawGraph: "Vykreslit",
                customShow: "Vykreslit vol. graf",
                customExport: "CSV Export reg. hodnot",
                pdfExport: "Spotřeba PDF Report",
                csvExport: "Spotřeba CSV Report",
                csvExportReading: "Odečet CSV Report",
                pdfExportReading: "Odečet PDF Report",
                pdfExportThreshold: "Tolerance chyb. záznamů [minuty]",
                exportInProgress: "Probíhá export, čekejte prosím…",
                presetLoading: "Načítání trendů sady, čekejte prosím…",
                presetGraphLoading: "Načítání dat trendů pro graf, čekejte prosím…",
                presetGraphTooManyTitle: "Příliš mnoho trendů pro graf",
                presetGraphTooMany: "Vykreslení více než {max} trendů v grafu není podporováno. Tato sada má {count} aktivních trendů.",
                exportHeaderDate: "Datum a čas",
                exportFileHeader: "Export hodnot (od - do):",
                exportHeaderValue: "Hodnota",
                exportSemicolon: "; (Středník)",
                exportComma: ", (Čárka)",
                maxGraphDraw: "Maximální počet pro vykreslení",
                toggleFullScreen: "Přepnout do Fullscreen módu",
                toggleZoom: "Zapnout/Vypnout zoom",
                setRange: "Nastavit Y-rozsah",
                clearRange: "Reset Y-rozsah",
                resetZoom: "Reset zoom",
                setCustomSize: "Nastavit velikost",
                resetSize: "Reset velikosti",
                graphWidth: "Šířka (px)",
                graphHeight: "Výška (px)",
                downloadGraph: "Stáhnout PNG",
                printGraph: "Vytisknout graf",
                setThresholds: "Nastavit meze",
                yThresholdMax1: "Y mez max 1",
                yThresholdMax2: "Y mez max 2",
                yThresholdMin1: "Y mez min 1",
                yThresholdMin2: "Y mez min 2",
                yThresholdLine1: "Mez 1",
                yThresholdLine2: "Mez 2",
                yThresholdLine3: "Mez 3",
                yThresholdLine4: "Mez 4",
                thresholdsHelp: "Až 4 volitelné vodorovné čáry na ose Y. Stejný čárkovaný tah. Použijte + pro použití.",
                graphYFrom: "Y od",
                graphYTo: "Y do",
                yRangeHelp: "Viditelný rozsah osy Y. Prázdné = automaticky. Použijte tlačítko rámečku pro použití.",
                sizeHelp: "Velikost grafu v pixelech. Lze zadat jen šířku, jen výšku, nebo obojí. Prázdné pole se přizpůsobí obrazovce.",
                iconLegendDownload: "PNG",
                iconLegendPrint: "Tisk",
                iconLegendFullscreen: "Celá obrazovka",
                iconLegendZoom: "Zoom",
                iconLegendClearRange: "Reset Y",
                iconLegendResetZoom: "Reset zoom",
                customToolsPanel: "Období a export",
                customToolsExport: "Export",
                customToolsConsumption: "Spotřeba",
                customToolsReading: "Odečet",
                chartSettingsPanel: "Nastavení grafu",
                reports: {
                    projectName: "Projekt",
                    presetName: "Sada",
                    userName: "Uživatel",
                    dateGen: "Datum generace",
                    id: "ID",
                    unit: "Jednotka",
                    description: "Popis",
                    consumption: {
                        dateFrom: "Datum od",
                        dateTo: "Datum do",
                        startValue: "Počáteční hodnota",
                        endValue: "Konečná hodnota",
                        sumValue: "Spotřeba",
                        totalSum: "Celkem",
                    },
                    reading: {
                        date: "Datum odečtu",
                        value: "Odečet"
                    },
                    footer: "Automaticky vygenerováno pomocí Tronic Control Viewer (www.vizleda.cz)"
                }
            },
            alarmsExport: {
                selectAll: "Vybrat/Zrušit vše",
                alarmsProject: "Poruchy",
                currentAlarms: "Aktuální poruchy",
                alarmsPage: "Poruchy v zadaném období",
                selectStations: "Vyberte stanice:",
                selectPreset: "Vyberte sestavu:",
                selectAlarms: "Vyberte poruchy:",
                exportAlarms: "Datum a vypsání:",
                mainText: "Pro vyexportování poruch prosím pokračujte v následujícím pořadí:",
                step1: "Vyberte stanice, pro které chcete vypsat poruchy",
                step2: "Vyberte poruchy, které chcete zobrazit",
                step3: "Vyberte období od-do",
                step4: "Nechte si vypsat poruchy",
                infoText: "Pokud chcete změnit svůj předešlý krok, je vždy možné se vrátit a data vygenerovat znova.",
                selectStationsConfirm: "Vybrat stanice",
                selectPresetConfirm: "Vybrat sestavu",
                selectAlarmsFinal: "Vybrat poruchy",
                downloadAlarms: "Stáhnout do CSV",
                generateAlarms: "Vypsat poruchy",
                noAlarmsGenerated: "Ve zvolených datech nenastaly žádné poruchy.",
                alarmsExported: "Poruchy úspěšně vypsány."
            },
            trendsExport: {
                trendsProject: "Registrace",
                trendsPage: "Zobrazení a export registrací",
                viewTrends: "Přehled registrací",
                mainText: "Pro zobrazení a vyexportování registrací prosím pokračujte v následujícím pořadí:",
                step1: "Vyberte stanice, pro které chcete vypsat registrace nebo vyberte sestavu",
                step2: "Vyberte registraci, kterou chcete zobrazit, případně přidejte do grafu další.",
                step3: "Pro export zvolte 'volitené' období a vyberte období od-do",
                step4: "Pro kontrolu je možné si libovolné období nechat zobrazit v grafu nebo rovnou použít 'CSV Export'",
                infoText: "Pokud chcete změnit vybrané stanice, je vždy možné se vrátit a registrace vygenerovat znova.",
                noTrendsGenerated: "Ve zvolených datech nejsou zaznamenány žádné registrace.",
                trendsExported: "Registrace úspěšně vypsány.",
                viewGraph: "Zobrazit graf registrace",
                addToGraph: "Přidat do existujícího grafu"
            },
            schedulesExport: {
                schedulesProject: "Časové programy",
                schedulesPage: "Časove programy stanice",
                schedulesStatus: "Status získávání dat",
                schedulesInfo: "Informace",
                schedulesType: "Typ stanice",
                schedulesLastUpdate: "Naposledy edidtováno",
                schedulesTable: "Časové programy",
                buttonUpdate: "Vyslat",
                buttonUpdateTitle: "Vyslat úpravu časových programů",
                buttonReset: "Reset",
                buttonResetTitle: "Reset a zažádat o nové časové programy",
                buttonStop: "Stop",
                buttonStopTitle: "Zastavit získavání dat manuálně",
                buttonDelete: "Smazat",
                buttonDeleteTitle: "Vymazat čas. programy z paměti systému",
                confirmationButton: "Potvrďte prosím:",
                notDeletedInfo: "Nepovedlo se vymazat čas. program. Zkuste refresh stránky"
            },
            eventsExport: {
                eventsProject: "Události",
                eventsPage: "Události v zadaném období",
                selectStations: "Vyberte stanice:",
                selectEvents: "Vyberte události:",
                exportEvents: "Datum a vypsání:",
                mainText: "Pro vyexportování událostí prosím pokračujte v následujícím pořadí:",
                step1: "Vyberte stanice, pro které chcete vypsat události",
                step2: "Vyberte události, které chcete zobrazit",
                step3: "Vyberte období od-do",
                step4: "Nechte si vypsat události",
                infoText: "Pokud chcete změnit svůj předešlý krok, je vždy možné se vrátit a data vygenerovat znova.",
                selectStationsConfirm: "Vybrat stanice",
                selectEventsFinal: "Vybrat události",
                downloadEvents: "Stáhnout do CSV",
                generateEvents: "Vypsat události",
                noEventsGenerated: "Ve zvolených datech nejsou zaznamenány žádné události.",
                eventsExported: "Události úspěšně vypsány."
            }
        },
        settings: {
            header: "Nastavení účtu",
            editAcc: "Upravit účet: ",
            nameReq: "Jméno je povinné",
            emailReq: "Email je povinný",
            name: "Jméno",
            address: "Adresa",
            contact: "Kontakt",
            primTelNum: "Primární tel. číslo",
            secTelNum: "Sekundární tel. číslo",
            ico: "ICO",
            dic: "DIC",
            subEdit: "Upravit účet",
            changePass: "Změna hesla",
            oldPass: "Staré heslo",
            oldPassReq: "Staré heslo je povinné",
            newPass: "Nové heslo",
            newPassReq: "Nové heslo je povinné",
            newPassConf: "Potrvzení nového hesla",
            newPassConfReq: "Potrvzení nového hesla je povinné",
            passErr: "Nové hesla nejsou stejné",
            confPassChange: "Potrvdit změnu hesla",
            succPassChange: "Heslo úspěšně změněno",
            noChanges: "Nebyly provedeny žádné změny",
            accSuccUpdate: "Účet úspěšně aktualizován"
        },
        other: {
            retrDataError: "Omlouváme se, ale momentálně nejsme schopni zobrazit požadované data, zkuste to prosím později",
            loading: "Načítání...",
            clear: "Smazat",
            searchHolder: "Pište pro hledání",
            filter: "Filtr",
            perPage: "Na stránku",
            p404Header: "Oops! Jste ztracený.",
            p404Text: "Stránka, kterou hledáte nebyla nalezena.",
            p401Header: "Oops! Tady byste neměl být.",
            p401Text: "Nemáte práva k přistupu na tuto stránku.",
            return: "Jít zpět"
        },
        manual: {
            title: "Uživatelský manuál",
            lead: "VizWeb Viewer. Jen pro obsluhu v prohlížeči.",
            search: "Hledat v manuálu",
            clear: "Smazat",
            print: "Tisk",
            prev: "Předchozí výskyt",
            next: "Další výskyt",
            toc: "Obsah",
            showToc: "Obsah",
            hideToc: "Skrýt obsah",
            nothing: "Nic nenalezeno.",
            parts: "Částí: {count}",
            foundParts: "Nalezeno částí: {count}",
            match: "{current} / {total}",
            printTitle: "VizWeb Viewer — uživatelský manuál",
            printLead: "Text pro uživatele a zákazníky. Snímky ukazují ovládání, ne konkrétní technologii."
        }
    }
};

export const i18n = new VueI18n({
    locale: 'cs',
    fallbackLocale: 'en',
    messages
});
